import type ReactDOM from 'react-dom/client';
import type { Site } from '@tamtamy/replycom-job-posts';

export class JobPostsRuntime extends HTMLElement {
    private root?: ReactDOM.Root;

    public async connectedCallback() {
        const { mount } = await import('@tamtamy/replycom-job-posts');
        this.root = mount(this, {
            language: this.dataset.language as Site,
            country: this.dataset.country,
            basePath: this.dataset.basepath,
            reCaptchaSiteKey: this.dataset.recaptchasitekey as string,
            searchEndpoint: this.dataset.searchendpoint as string,
            jobappEndpoint: this.dataset.jobappendpoint as string,
            publicEndpoint: this.dataset.publicendpoint as string
        });
    }

    public disconnectedCallback() {
        this.root?.unmount();
    }
}